<div class="checkbox-dialog-container">
  <h1 mat-dialog-title>
    <span>{{ title | transloco }}</span>
  </h1>
  <mat-dialog-content>
    <div>{{ getDescription() }}</div>
  </mat-dialog-content>
  <mat-checkbox [color]="'primary'" [(ngModel)]="checkbox">
    <span class="checkbox-description">{{ checkboxDescription | transloco }}</span>
  </mat-checkbox>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close><span>{{ 'dialog.button.cancel.label' | transloco }}</span></button>
    <button
      mat-flat-button
      mat-dialog-close="true"
      color="warn"
      [disabled]="!checkbox"
    >
      {{ confirmButtonLable | transloco }}
    </button>
  </mat-dialog-actions>
</div>
